<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1200px"
      show-save-button
      unit="布产单"
      edit-title
      id-key="UserId"
      :data="data"
      :line-form="true"
      :get-data-func="api.info"
      form-label-width="100px"
      @close-saved="$emit('close-saved')"
      label-position="left"
      @details-opened="detailsOpened"
    >
      <template slot="form">
        <el-row class="border">
          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item label="订单号" prop="Order">
                <span>{{ data.Order }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="布产单号" prop="SubOrder">
                <span>{{ data.SubOrder }}</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item label="单据日期" prop="DocTime">
                <span>{{ data.DocTime }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="客户名称" prop="CustomerName">
                <span>{{ data.CustomerName }}</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item label="部门" prop="Team">
                <span>{{ data.Team }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="业务员" prop="Salesman">
                <span>{{ data.Salesman }}</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item label="存货编码" prop="InventoryCode">
                <span>{{ data.InventoryCode }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="存货名称" prop="InventoryName">
                <span>{{ data.InventoryName }}</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item label="颜色" prop="Color">
                <span>{{ data.Color }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="单位" prop="Unit">
                <span>{{ data.Unit }}</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item label="订单数量" prop="OrderQuantity">
                <span>{{ data.OrderQuantity }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="库存可用量" prop="StocksQuantity">
                <span>{{ data.StocksQuantity }}</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item label="BOM版本号" prop="BomVesion">
                <el-input v-if="!readonly" clearable v-model="data.BomVesion" placeholder="请输入BOM版本号"></el-input>                
                <span v-else>{{ data.BomVesion }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="生产数量" prop="scQuantity">
                <el-input  v-if="!readonly" clearable v-model="data.scQuantity" placeholder="请输入生产数量"></el-input>                
                <span v-else>{{ data.scQuantity }}</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item label="生产部门" prop="scTeam">
                 <el-input  v-if="!readonly" clearable v-model="data.scTeam" placeholder="请输入生产部门"></el-input>            
                <span v-else>{{ data.scTeam }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>

        <el-tabs tab-position="top" >
          <el-tab-pane label="注塑工单">
            <injection-molding ref="injection" :readonly="readonly" :jiaojianlist="jiaojian_List" :mould-list="mould_list" :inner-list="inner_list"></injection-molding>
          </el-tab-pane>
          <el-tab-pane label="特殊工艺工单">
            <special-process></special-process>
          </el-tab-pane>
          <el-tab-pane label="配件工单">
            <parts-order :inner-data="innerDatapartsOrder"></parts-order>
          </el-tab-pane>
          <el-tab-pane label="装配工单">
            <assembly-order :inner-data="innerDataAssemblyOrder"></assembly-order>
          </el-tab-pane>
          <el-tab-pane label="组合工单">
            <combination-order :inner-data="innerDataCombinationOrder"></combination-order>
          </el-tab-pane>
        </el-tabs>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import injectionMolding from "./workorder/injectionMolding";
import specialProcess from "./workorder/specialProcess";
import partsOrder from "./workorder/partsOrder";
import assemblyOrder from "./workorder/assemblyOrder";
import combinationOrder from "./workorder/combinationOrder";

import {historicalclothApi, clothDialogApi, clothDialog1Api, clothDialog12Api, clothDialog3Api} from '@/data/production/test'

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    injectionMolding,
    specialProcess,
    partsOrder,
    assemblyOrder,
    combinationOrder,
  },
  props: {
    readonly: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      api: historicalclothApi,
      capi: clothDialogApi,
      capi1: clothDialog1Api,
      capi2: clothDialog12Api,
      capi3: clothDialog3Api,
      data: {
        Order: '',
        SubOrder: '',
        DocTime: '',
        CustomerName: '',

        Team: '',
        Salesman: '',
        InventoryCode: '',
        InventoryName: '',

        BomVesion: '',
        Color: '',
        Unit: '',
        OrderQuantity: '',
        StocksQuantity: '',
        scQuantity: '',
        scTeam: '',
      },
      jiaojian_List: [],
      mould_list: [],
      inner_list: [],
      innerDatapartsOrder: [],
      innerDataAssemblyOrder: [],
      innerDataCombinationOrder: [],


    };
  },
  created(){
   this.capi.list().then(res => {
    let data = [];
    for(let i = 0; i < res.Data.length; ++i){
      let arr = [];
      arr.push(res.Data[i]);
      data.push(arr)
    }
    this.inner_list = data
   })

  this.capi1.list().then(res => {
    let data = [];
    for(let i = 0; i < res.Data.length; ++i){
      let arr = [];
      arr.push(res.Data[i]);
      data.push(arr)
    }
    this.innerDatapartsOrder = data
   })

   this.capi2.list().then(res => {
    let data = [];
    for(let i = 0; i < res.Data.length; ++i){
      let arr = [];
      arr.push(res.Data[i]);
      data.push(arr)
    }
    this.innerDataAssemblyOrder = data
   })

   this.capi3.list().then(res => {
    let data = [];
    for(let i = 0; i < res.Data.length; ++i){
      let arr = [];
      arr.push(res.Data[i]);
      data.push(arr)
    }
    this.innerDataCombinationOrder = data
   })
  },
  methods: {
    save(row) {},
    viewImg(imgURL) {},
    

    detailsOpened(data){
      this.jiaojian_List = data.jiaojianList;
      this.mould_list = data.mojulist;

      
    }
  },
};
</script>

<style lang="scss" scoped>
.el-tabs {
  margin: 18px;
}
</style>
